import { httpRequest } from "../../../utils/HttpRequest";
import { IPayableList, IPayableSearch } from "./payableTypes"
class Payableservice {
    async copeWith(params: IPayableSearch) {
        const apiUrl = `/statement/copeWith`;
        return await httpRequest.post<IPayableList>(apiUrl, params);
    }
    async copeWithExcel(params: IPayableSearch) {
        const apiUrl = `/statement/copeWithExcel`;
        return await httpRequest.postFile(apiUrl, params);
    }
}
export const payableService = new Payableservice();
